module.exports = __webpack_public_path__ + "img/Tony_G.24c72bec.png";